import { useState } from 'react'
import type { ServerSiteMembership } from '../../data/ServerApiClient'

type SetupLink = { setup_url: string; expires_at: string }
type Props = {
  member: ServerSiteMembership
  generateLink: () => Promise<SetupLink>
}

export function SiteUserAccess({ member, generateLink }: Props) {
  const buttonStyle = { border: '1px solid #e7e3d8', borderRadius: 8, background: '#fff', padding: '7px 10px', fontWeight: 600, color: '#1d4c64', cursor: 'pointer' }
  const [link, setLink] = useState<SetupLink | null>(null)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [copied, setCopied] = useState(false)
  return <div style={{ fontSize: 12, marginTop: 8, display: 'grid', gap: 6 }}>
    <div>{member.setup_pending === undefined ? 'Setup status unavailable' : member.setup_pending ? 'Setup pending' : 'Setup completed'}</div>
    <div>{member.last_sign_in_at
      ? `Last successful sign-in: ${new Date(member.last_sign_in_at).toLocaleString()}`
      : 'No successful sign-in recorded'}</div>
    {member.can_generate_setup_link && <button type="button" disabled={busy} style={{ ...buttonStyle, justifySelf: 'start' }} onClick={async () => {
      setBusy(true)
      setError('')
      setLink(null)
      setCopied(false)
      try { setLink(await generateLink()) }
      catch (err) { setError(err instanceof Error ? err.message : 'Could not generate setup link') }
      finally { setBusy(false) }
    }}>{busy ? 'Generating…' : 'Generate setup link'}</button>}
    {link && <div role="group" aria-label={`Setup link for ${member.email}`} style={{ display: 'grid', gap: 6, maxWidth: 560 }}>
      <div>Send this link directly to {member.email}&apos;s owner through a verified channel. They choose their own password. No email delivery is required.</div>
      <div>Expires {new Date(link.expires_at).toLocaleString()}. Usable once. Generating another link replaces earlier setup links.</div>
      <input style={{ width: '100%', boxSizing: 'border-box', border: '1px solid #ddd', borderRadius: 6, padding: 8 }} aria-label={`Setup URL for ${member.email}`} value={link.setup_url} readOnly onFocus={event => event.target.select()} />
      <div style={{ display: 'flex', gap: 8 }}>
        <button type="button" style={buttonStyle} onClick={async () => {
          try { await navigator.clipboard.writeText(link.setup_url); setCopied(true); setError('') }
          catch { setError('Select the link above and copy it manually.') }
        }}>{copied ? 'Copied' : 'Copy link'}</button>
        <button type="button" style={buttonStyle} onClick={() => { setLink(null); setError('') }}>Hide link</button>
      </div>
    </div>}
    {error && <div role="alert">{error}</div>}
  </div>
}
